import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import WhatsAppButton from '@/components/feature/WhatsAppButton';
import Hero from './components/Hero';
import WhatYouFind from './components/WhatYouFind';
import WhatYouCreate from './components/WhatYouCreate';
import Benefits from './components/Benefits';
import PerfectFor from './components/PerfectFor';
import Bonus from './components/Bonus';
import FAQ from './components/FAQ';
import FinalCTA from './components/FinalCTA';

export default function AdvertisingPrompts() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <Hero />
        <WhatYouFind />
        <WhatYouCreate />
        <Benefits />
        <PerfectFor />
        <Bonus />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}